export default {
  blank: () => import("/home/runner/work/livia_v0/livia_v0/layouts/blank.vue"),
  default: () => import("/home/runner/work/livia_v0/livia_v0/layouts/default.vue")
}